import { environment } from "src/environments/environment";

export const SIGIH_API = environment.api
export const SIGIH_AUTH = environment.auth